import { decorate, observable } from 'mobx';

import { LocationResponse } from 'tm3-core/api.dtos';

decorate(LocationResponse, {
  addressLine1: observable,
  addressLine2: observable,
  addressLine3: observable,
  addressLine4: observable,
  addressLine5: observable,
  cancelStockId: observable,
  directions: observable,
  dnaStockId: observable,
  email: observable,
  facilities: observable,
  fax: observable,
  fullAddressMultiLine: observable,
  id: observable,
  isMainLocation: observable,
  name: observable,
  onlineGuid: observable,
  postCode: observable,
  reminderTemplateEmail_TM3: observable,
  reminderTemplateSMS_TM3: observable,
  status: observable,
  telephone: observable,
  web: observable
});

export default LocationResponse;
